export const USER_SERVICE = 'user_service';
export const NOTION_CLIENT = 'notion_client';
export const NOTION_DATABASE_SERVICE = 'notion_database_service';
export const WORKSPACE_SERVICE = 'workspace_service';
export const TEMPLATE_SERVICE = 'template_service';
export const HISTORY_SERVICE = 'history_service';
export const SETTINGS_SERVICE = 'settings_service';
export const FIREBASE_APP = 'firebase_app';
export const EVENT_BUS = 'event_bus';
export const BROWSER_SERVICE = 'browser_service';
export const SUBSCRIPTION_MANAGER = 'subscription_manager';
export const BETA_PHASE_MANAGER = 'beta_phase_manager';
export const BREAKPOINT_MANAGER = 'breakpoint_manager';

export const FILE_UPLOAD_LIMIT = 10000000;
export const FILE_UPLOAD_LIMIT_VIDEO = 10000000;

export const FREE_STORAGE_LIMIT = 50 * 1000 * 1000; // 50 Mb
export const BASIC_STORAGE_LIMIT = 1000 * 1000 * 1000; // 1000 Mb = 1 Gb

export const STORAGE_HINT_LIMIT = 80; // 80 % of the maximum

export const featureFlags = {
  aiProperties: 'aiProperties',
  pageBlocks: 'pageBlocks',
};
export const plans = {
  free: {
    id: 'free',
    productId: import.meta.env.VITE_FREE_PADDLE_PRODUCT_ID,
    featureAccess: {
      [featureFlags.aiProperties]: false,
      [featureFlags.pageBlocks]: false,
    },
  },
  basic: {
    id: 'basic',
    productId: import.meta.env.VITE_BASIC_PADDLE_PRODUCT_ID,
    featureAccess: {
      [featureFlags.aiProperties]: true,
      [featureFlags.pageBlocks]: true,
    },
  },
};

export const paddleSubscriptionActions = {
  cancel: 'cancel',
  checkout: 'checkout',
  reactivate: 'reactivate',
}

export const paddleSubscriptionTrials = {
  noTrial: 'no-trial',
  trial: 'trial',
}

export const C_BLOCK_TYPE_TEXT = 'text';
export const C_BLOCK_TYPE_PAGE_URL = 'page_url';
export const C_BLOCK_TYPE_VISIBLE_AREA_SCREENSHOT = 'screenshot_visible_area';
export const C_BLOCK_TYPE_SELECTION = 'selection';
export const C_BLOCK_TYPE_AI = 'ai';
export const C_BLOCK_TYPE_COOKIES = 'cookies';
export const C_BLOCK_TYPE_LOCAL_STORAGE = 'local_storage';
export const C_AI_TARGET_SELECTION = 'selection';
export const C_AI_TARGET_FULL_BODY = 'full_body';
